import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_add_room",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "add_room",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_add_room_button",
  "data-kt-drawer-close": "#kt_drawer_add_room_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_add_room",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_add_room_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Add Room Details </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_add_room_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_add_room_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_add_room_body",
  "data-kt-scroll-dependencies": "#kt_add_room_header, #kt_add_room_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_add_room_scroll"
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Room No", -1)
const _hoisted_12 = { class: "row mt-3" }
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Location", -1)
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Capacity", -1)
const _hoisted_18 = { class: "row mt-3" }
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Lab Equipment", -1)
const _hoisted_21 = {
  class: "py-5 text-center",
  id: "kt_add_room_footer"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_add_room_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_23 = ["data-kt-indicator"]
const _hoisted_24 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_25 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_26 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.room_num,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.room_num) = $event)),
                          name: "room_num",
                          class: "form-control",
                          rows: "3"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "room_num",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_Field, {
                          name: "room_location",
                          modelValue: _ctx.room_location,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.room_location) = $event)),
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "room_location",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.room_capacity,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.room_capacity) = $event)),
                          name: "room_capacity",
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "room_capacity",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.room_equipment,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.room_equipment) = $event)),
                          name: "room_equipment",
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "room_equipment",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_25, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_27
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_23)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}